import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export function NotFound() {
    const navigate = useNavigate();
    const [count, setCount] = useState(10);

    useEffect(() => {
        if (count <= 0) {
            navigate('/');
            return
        };

        const timer = setInterval(() => {
            setCount((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [count, navigate]);

    return (
        <>
            <div className="container-fluid">
                <div>Deze pagina kan niet worden gevonden. Ga naar de <a href="/">Homepage</a> of wacht {count} seconden om automatisch te worden doorgestuurd.</div>
            </div>
        </>
    );
}